<template>
  <div class="comp-footer-vip">
    <div v-show="fixFooter" class="comp-footer-vip">
      <div class="vip-inner content">
        <p>
          <img class="va-t" src="../assets/icon/vip_icon.png" alt="">
          <span class="tit ml5">考试在线VIP会员</span>
          <span class="sub-tit ml10 f18">畅享百万优质试题资源 一键智能快捷组卷</span>
        </p>
        <p><button class="v-btn f16" v-before:login="{handler: bindVipBuy, success: initBuyType}">开通VIP会员</button></p>
      </div>
    </div>
  </div>
</template>

<script>
  /**
   * @author yueheqin
   * @date 2018/12/28
   * @project kaoshizhongxin-pc
   * @desc
   */
  import { mapState, mapMutations } from 'vuex'
  export default {
    name: 'comp-footer-vip',
    props: {},
    data () {
      return {
        footerTop: 0,
        docHeight: 0,
        winHeight: 0,
        fixFooter: false
      }
    },
    computed: {
      ...mapState(['scrollTop'])
    },
    watch: {
      scrollTop (v) {
        // console.log(v, this.winHeight, this.footerTop, this.docHeight, this.docHeight - this.winHeight)
        this.fixFooter = (v <= this.docHeight - this.winHeight - 110 && v > 450)
      }
    },
    mounted () {
      let $footer = $('.comp-footer-vip')
      let $doc = $('#app')
      this.footerTop = $footer.offset().top
      this.docHeight = $doc.height()
      this.winHeight = $(window).height()
    },
    methods: {
      ...mapMutations('vip', ['handlePayDialogVisible']),
      bindVipBuy () {
        if (this.$route.name === 'VIP') {
          // this.handlePayDialogVisible(true)
        } else {
          this.$router.push({name: 'VIP'})
        }
      },
      initBuyType () {
        this.getPayType()
      }
    }
  }
</script>

<style lang="less">
  .comp-footer-vip {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 20;
    box-shadow: 0 3px 3px 5px rgba(3,26,62,0.18);
    height: 100px;
    background: #383838;
    width: 100%;
    color: #ECC16D;
    transition: transform .3s;
    .vip-inner{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      .tit{
        font-size: 34px;
      }
      button{
        display: inline-block;
        background: #FF9900;
        text-align: center;
        width: 260px;
        color: #ffffff;
        border: none;
        line-height: 50px;
        &:hover{
          opacity: 0.9;
        }
      }
    }
  }
</style>
